module.exports = __webpack_public_path__ + "img/db1fa468fed3d060a68c0fe5dc6022f7.b0e2143c.png";